module.exports = __webpack_public_path__ + "img/empty-battle-bg2.28b7c1b7.png";